import { z } from 'zod';
import { uuid } from './primitives.js';
export const roadmapSchema = z.object({
    id: uuid,
    gameId: uuid,
    trophySetId: uuid,
    title: z.string().min(1),
    currentPhaseId: uuid.nullable(),
    currentStepId: uuid.nullable(),
});
export const roadmapPhaseSchema = z.object({
    id: uuid,
    roadmapId: uuid,
    title: z.string().min(1),
    order: z.number().int().nonnegative(),
});
export const roadmapStepSchema = z.object({
    id: uuid,
    phaseId: uuid,
    title: z.string().min(1),
    category: z.string().nullable(),
    order: z.number().int().nonnegative(),
    shortInstruction: z.string().nullable(),
    spoilerHint: z.string().nullable(),
    pointOfNoReturn: z.boolean(),
});
/** n:m – ein Step kann mehrere Trophaeen haben, eine Trophy mehrere Steps. */
export const roadmapStepRelationTypeSchema = z.enum(['primary', 'related']);
export const roadmapStepTrophySchema = z.object({
    roadmapStepId: uuid,
    trophyId: uuid,
    relationType: roadmapStepRelationTypeSchema,
});
/** Missables sind Verknuepfungen, kein Freitext. */
export const missableTargetTypeSchema = z.enum(['trophy', 'mission', 'step', 'event']);
export const roadmapStepMissableSchema = z.object({
    roadmapStepId: uuid,
    targetType: missableTargetTypeSchema,
    targetId: z.string().min(1),
    cutoffStepId: uuid.nullable(),
    note: z.string().nullable(),
});
/** Ein Step kann 0, 1 oder mehrere Map-Objekte besitzen. */
export const roadmapStepMapLinkSchema = z.object({
    roadmapStepId: uuid,
    vmapsTargetId: z.string().min(1),
    label: z.string().nullable(),
});
/** Fortschritt eines Nutzers auf einem Step. User-Daten, keine Redaktionsdaten. */
export const userRoadmapStepStateSchema = z.object({
    userGameRunId: uuid,
    roadmapStepId: uuid,
    completed: z.boolean(),
});
//# sourceMappingURL=roadmap.js.map